/**
 * `/market/sell` — search schema.
 *
 *   ?packId=<uuid>  the pack being edited. Optional: with no packId the screen
 *                   is the list of your packs and the form that starts a new
 *                   one, which is where a first-time seller lands.
 *
 * Kept as a free-form string rather than validated as a uuid here, for the same
 * reason as the checkout: the gateway answers a malformed id exactly the way it
 * answers an id that names nothing, so a client-side format check would only
 * move the refusal earlier and give the two answers different shapes.
 */
import { createFileRoute } from '@tanstack/react-router';

export interface MarketSellSearch {
  packId?: string;
}

export function validateMarketSellSearch(search: Record<string, unknown>): MarketSellSearch {
  const raw = search?.packId;
  const packId = typeof raw === 'string' && raw.length > 0 && raw.length <= 64 ? raw : undefined;
  return { ...(packId ? { packId } : {}) };
}

export const Route = createFileRoute('/_authenticated/market/sell')({
  validateSearch: validateMarketSellSearch,
});
